import { startInstapost } from "../../../services/assetsGenerationAPI";

export const handleStartGeneratingInstapost = async ({
  publicationId,
  token,
  postSection,
  postContentLevel,
  setActiveTasks,
  setTaskStatus,
  setAlert,
  setupWebSocket,
  setOpenInstapostDialog,
  setRefreshTrigger = null,
}) => {
  try {
    const uniqueId = "pending";
    setActiveTasks((prev) => {
      const nextArr = [...(prev.instapost || [])];
      if (!nextArr.includes(uniqueId)) nextArr.push(uniqueId);
      return { ...prev, instapost: nextArr };
    });
    localStorage.setItem("activeTasks", "true");
    setTaskStatus(prev => ({
      ...prev,
      instapost: {
        ...(prev.instapost || {}),
        [uniqueId]: { progress: 0, status: "queued", publicationId: Number(publicationId) }
      }
    }));

    const result = await startInstapost(publicationId, token, {
      uploadedType: postSection,
    });

    if (result.error) {
      setAlert({ severity: "warning", message: result.error });
      setActiveTasks(prev => ({ ...prev, instapost: (prev.instapost || []).filter(id => id !== "pending") }));
    } else if (result.task_id) {
      setActiveTasks(prev => ({ ...prev, instapost: (prev.instapost || []).filter(id => id !== "pending") }));
      setupWebSocket(result.task_id, "instapost", publicationId, null, (message, severity) => {
        setAlert({ severity, message });
      });
      setAlert({
        severity: "success",
        message: "Post Generation Started",
      });
      if (setRefreshTrigger) {
        setRefreshTrigger(prev => prev + 1);
      }
      setOpenInstapostDialog(false);
    }
  } catch (error) {
    setAlert({
      severity: "warning",
      message: "Failed to start Post generation. Please try again.",
    });
    setActiveTasks(prev => ({ ...prev, instapost: (prev.instapost || []).filter(id => id !== "pending") }));
  }
  setOpenInstapostDialog(false);
};

export const handleOpenInstapostDialog = (setOpenInstapostDialog) => {
  setOpenInstapostDialog(true);
};

export const handleCloseInstapostDialog = (setOpenInstapostDialog) => {
  setOpenInstapostDialog(false);
};
